// src/components/Hero.jsx
import styles from '../styles/Hero.module.css';
import T, { useTranslate } from './T';

function getFirstName(fullName) {
  return fullName ? fullName.split(' ')[0] : '';
}

function getGreetingKey() {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

export default function Hero({ userName = 'Tunde Usman' }) {
  const firstName = getFirstName(userName);
  const greetingKey = getGreetingKey();
  const { tText } = useTranslate();

  return (
    <section className={styles.hero}>
      {/* Subtle ambient orbs */}
      <div className={`${styles.orb} ${styles.orb1}`} />
      <div className={`${styles.orb} ${styles.orb2}`} />

      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.eyebrow}>
            <div className={styles.eyebrowDot} />
            <span className={styles.eyebrowText}><T>Autochek Internal Portal</T></span>
          </div>

          <h1 className={styles.heading}>
            {tText(greetingKey)}, <span className={styles.accent}>{firstName}</span>
          </h1>
        </div>

        <div className={styles.right}>
          <p className={styles.sub}>
            <T>Raise a request, report an incident, or get access to the tools you need — all in one place</T>
          </p>

          <div className={styles.stats}>
            <div className={styles.stat}>
              <span className={styles.statValue}>~2h</span>
              <span className={styles.statLabel}><T>response time</T></span>
            </div>
            <div className={styles.statDivider} />
            <div className={styles.stat}>
              <span className={styles.statValue}><T>Sécurisé</T></span>
              <span className={styles.statLabel}><T>Secure Staff access</T></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
